<template>
    <div>
        <div v-for="(choice, index) in choiches" v-bind:key="uniqueName+'-'+index" style="position: relative;">     
            <select v-model="choiches[index]" :class="aspect.formFieldClass">
                <option v-if='placeholder && placeholder.length > 0' :value="null" disabled v-html="placeholder"></option>
                <option v-for="(option, key) in options" :key="'name-'+key" :value="key">{{selectVal(option)}}</option>
            </select>
            <i class="fa fa-times" v-if="index > 0" @click="removeRow(index)" style="position: absolute; top: 10px; right: 20px; font-size: 20px; cursor:pointer; "></i>
        </div>
        <div @click="addRow()" style="cursor: pointer; margin-top: -10px;" v-html="translations.addMultipleSelectLabel"></div>
    </div>
</template>

<script>
    export default {
        name: 'form-element-select-multiple',
        props: {
            value:{type:Array},
            translations: {type: Object},
            aspect: {type: Object, default: function(){ return {}; }},
            disabled: {type: Boolean, default: false},
            options: {type: Object, default: function(){ return {}; }},
            placeholder: {type: String, default: null},
            uniqueName: {type: String, default: null},
            name: {type: String, default: null},
        },
        data(){
            return {
                choiches: [null],
            }
        },
        watch: {
            choiches: {
                deep: true,
                handler(){
                    this.$emit('input', this.choiches);
                }
            }
        },
        methods: {
            selectVal(option){
				return (option.select_option_value)?option.select_option_value:option;
            },
            removeRow(index){
                this.choiches.splice(index,1);
            },
            addRow(){
                this.choiches.push(null);
                return false;
            },
            evaluateValidationCondition(condition){
                if(condition.type=="at_least_one"){
                    var count = 0;
                    for(var i=0; i < this.choiches.length; i++){
                        if(this.choiches[i] != null){ count += 1; }
                    }
                    return count==0?this.translations.atLeastOneOptionWarning:null
                }
            }
        }
    }
</script>